import { PersistSettingsBackendService } from './persist-settings-backend.service';
import { PersistSettingsLocalService } from './persist-settings-local.service';
import { PersistencyTypes } from './persistency-types';

export const persistSettingsServiceBuilder = (persistencyType: PersistencyTypes) => {
  switch (persistencyType) {
    case PersistencyTypes.Backend:
      return PersistSettingsBackendService;
    case PersistencyTypes.Local:
      return PersistSettingsLocalService;
    default:
      throw Error(
        `Could not determine the persistency service corresponding to ${persistencyType}`
      );
  }
};
